<script>
import { clearAuth } from '@/assets/js/Authentication'

export default {
  created () {
    clearAuth()
    this.$router.push({ name: 'Login' })
  }
}
</script>
